import React, { useState, useEffect, useContext } from "react"
import { useSelector, useDispatch } from "react-redux"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { changeAshiCount, changeChartDate } from "redux/ducks/Chart"
import {
  convertDate,
  checkDataSpan,
  updateSpan,
  getFutureSpan,
} from "../logic/chartSpan"
import { TOOLS, PLOTTYPE, CHART_ASHI_MIN } from "../logic/chartConfig"
import { pickTarget } from "redux/ducks/Chart"
import { find, pick } from "lodash"
import dayjs from "dayjs"
import classNames from "classnames"
import { ChartFlagContext } from "components/atoms/chart"

interface Window {
  notificationSystem: any
  spinnerService: any
}

declare var window: Window

interface props {
  canvasId: string
}

const DATEPICKER_FORMAT = "yyyy/MM/dd"
const DAYJS_FORMAT = "YYYYMMDD"

const ChartDatePicker = (props: props) => {
  const { canvasId } = props
  const chartFlagContext = useContext(ChartFlagContext)
  const { flag, setFlag } = chartFlagContext.scrollFlag
  const dispatch = useDispatch()
  const providersSelector = (state: any) => state.chart[canvasId].providers
  const plotTypeSelector = (state: any) => state.chart[canvasId].plotType
  const termSelector = (state: any) => state.chart[canvasId].term
  const dateSelector = (state: any) => state.chart[canvasId].date
  const toolsSelector = (state: any) => state.chart[canvasId].tools
  const providers = useSelector(providersSelector)
  const plotType = useSelector(plotTypeSelector)
  const term = useSelector(termSelector)
  const date = useSelector(dateSelector)
  const tools = useSelector(toolsSelector)
  const [_provider, _controller, _procs] = providers
  const [visible, setVisible] = useState(
    (() => {
      return term.id <= 7
    })()
  )
  const loupeFlag = !!find(tools, pick(TOOLS[4], pickTarget))
  const PandFFlag = plotType.id === PLOTTYPE[3].id

  const [startDate, setStartDate] = useState(date[0])
  const [endDate, setEndDate] = useState(date[1])

  const changeDate = (date: { sDate?: Date; eDate?: Date }) => {
    const { sDate, eDate } = date
    if (loupeFlag) return
    if (flag) return setFlag(false)
    const convertStartDate = Number(
      dayjs(sDate || startDate).format(DAYJS_FORMAT)
    )
    const convertEndDate = Number(dayjs(eDate || endDate).format(DAYJS_FORMAT))
    const [isCheck, _startDate, _endDate] = checkDataSpan(
      convertStartDate,
      convertEndDate,
      _controller
    )
    if (!_startDate || !_endDate) return
    if (!isCheck && !find(tools, pick(TOOLS[4], pickTarget))) {
      alert(
        `指定期間は本数が${CHART_ASHI_MIN +
          getFutureSpan(_controller)}以上になる期間を指定してください`
      )
      return
    }
    const [ashi, startSpan, endSpan] = updateSpan(
      convertStartDate,
      convertEndDate,
      _controller
    )
    const _sspan = convertDate(startSpan)
    const _espan = convertDate(endSpan)
    dispatch(
      changeChartDate(canvasId, [
        new Date(_sspan[0], _sspan[1], _sspan[2]),
        new Date(_espan[0], _espan[1], _espan[2]),
      ])
    )
    dispatch(changeAshiCount(canvasId, ashi))
    _controller.Chart.Draw()
  }

  useEffect(() => {
    if (
      dayjs(startDate).format("") === dayjs(date[0]).format("") &&
      dayjs(endDate).format("") === dayjs(date[1]).format("")
    )
      return
    setStartDate(date[0])
    setEndDate(date[1])
  }, [date])

  useEffect(() => {
    setVisible(!(term.id <= 7))
  }, [term])

  return (
    <div
      className={classNames("datepicker-wrapper filter-control-item", {
        disabled: !visible || loupeFlag || PandFFlag,
      })}
    >
      <DatePicker
        onChange={date => {
          setStartDate(date)
          changeDate({ sDate: date })
        }}
        selected={startDate}
        dateFormat={DATEPICKER_FORMAT}
        maxDate={endDate}
        dropdownMode={"scroll"}
        selectsStart
        showYearDropdown
      />
      <div className="symbol-term">～</div>
      <DatePicker
        onChange={date => {
          setEndDate(date)
          changeDate({ eDate: date })
        }}
        selected={endDate}
        dateFormat={DATEPICKER_FORMAT}
        startDate={startDate}
        minDate={startDate}
        dropdownMode={"scroll"}
        selectsEnd
        showYearDropdown
      />
    </div>
  )
}

export default ChartDatePicker
